import { createContext, useContext } from "react";
const InputLabelContext = createContext({}), useCheckInputLabel = (label) => {
  const { inputId } = useContext(InputLabelContext);
  if (!inputId && !label)
    throw new Error(
      "Tried to render an input element without an accessible label. Please check that all input components have a non-empty `title` prop."
    );
};
export {
  InputLabelContext,
  useCheckInputLabel
};
